/* Copyright (c) 2020-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

export const COLORS = [
  "#e91e63",
  "#9c27b0",
  "#3f51b5",
  "#00bcd4",
  "#009688",
  "#8bc34a",
  "#fdd835",
] as const;
